export const formatEnumToSelectOptions = values => Object.keys(values).map(key => ({
    value: values[key],
    text: key
}));
